import { Dialog, Portal } from "@chakra-ui/react";
import { forwardRef } from "react";
import { getThemeColor } from "theme/colors";

// Re-export Portal so dialog consumers can keep direct @chakra-ui/react imports
// out of their files (project rule: import only from components/ui).
export { Portal as DialogPortal };

// Dialog Root
export const DialogRoot = Dialog.Root;

// Dialog Content with themed styling
export const DialogContent = forwardRef((props: any, ref) => (
  <Dialog.Content
    ref={ref}
    bg={getThemeColor("bg.primary")}
    borderColor={getThemeColor("border.default")}
    {...props}
  />
));

// Dialog Header with themed styling
export const DialogHeader = forwardRef((props: any, ref) => (
  <Dialog.Header
    ref={ref}
    borderBottomWidth="1px"
    borderColor={getThemeColor("border.default")}
    {...props}
  />
));

// Dialog Title with themed styling
export const DialogTitle = forwardRef((props: any, ref) => (
  <Dialog.Title
    ref={ref}
    color={getThemeColor("modal.headerText")}
    {...props}
  />
));

// Dialog Body with themed styling
export const DialogBody = forwardRef((props: any, ref) => (
  <Dialog.Body ref={ref} color={getThemeColor("text.primary")} {...props} />
));

// Dialog Footer with themed styling
export const DialogFooter = forwardRef((props: any, ref) => (
  <Dialog.Footer
    ref={ref}
    borderTopWidth="1px"
    borderColor={getThemeColor("border.default")}
    {...props}
  />
));

// Dialog ActionTrigger (for triggering dialog close)
export const DialogActionTrigger = Dialog.ActionTrigger;

// Dialog Backdrop
export const DialogBackdrop = Dialog.Backdrop;

// Dialog Positioner
export const DialogPositioner = Dialog.Positioner;

// Dialog CloseTrigger
export const DialogCloseTrigger = Dialog.CloseTrigger;
